import {
  ALargeSmall,
  BookOpen,
  Bot,
  Building,
  Building2,
  Database,
  Feather,
  FileText,
  Gavel,
  GraduationCap,
  IdCard,
  Image,
  KeyRound,
  LayoutTemplate,
  Lock,
  MapPin,
  MessageSquareQuote,
  Monitor,
  PanelBottom,
  Palette,
  Quote,
  Smartphone,
  Sparkles,
  StickyNote,
  Type,
  Wrench,
} from 'lucide-react';
import { createLucideIcon } from '../createLucideIcon';

// Content / object / domain icons.
export const DescriptionIcon = /* #__PURE__ */ createLucideIcon('Description', FileText);
export const NoteIcon = /* #__PURE__ */ createLucideIcon('Note', StickyNote);
export const StickyNote2Icon = /* #__PURE__ */ createLucideIcon('StickyNote2', StickyNote);
export const ImageIcon = /* #__PURE__ */ createLucideIcon('Image', Image);
export const FormatQuoteIcon = /* #__PURE__ */ createLucideIcon('FormatQuote', Quote);
export const MessageSquareQuoteIcon = /* #__PURE__ */ createLucideIcon('MessageSquareQuote', MessageSquareQuote);
export const TextFieldsIcon = /* #__PURE__ */ createLucideIcon('TextFields', Type);
export const PanelBottomIcon = /* #__PURE__ */ createLucideIcon('PanelBottom', PanelBottom);
export const ALargeSmallIcon = /* #__PURE__ */ createLucideIcon('ALargeSmall', ALargeSmall);
export const AutoStoriesIcon = /* #__PURE__ */ createLucideIcon('AutoStories', BookOpen);
export const HistoryEduIcon = /* #__PURE__ */ createLucideIcon('HistoryEdu', Feather);
export const StorageIcon = /* #__PURE__ */ createLucideIcon('Storage', Database);
export const PaletteIcon = /* #__PURE__ */ createLucideIcon('Palette', Palette);
export const GavelIcon = /* #__PURE__ */ createLucideIcon('Gavel', Gavel);
export const HandymanIcon = /* #__PURE__ */ createLucideIcon('Handyman', Wrench);
export const SmartphoneIcon = /* #__PURE__ */ createLucideIcon('Smartphone', Smartphone);
export const SmartphoneOutlinedIcon = /* #__PURE__ */ createLucideIcon('SmartphoneOutlined', Smartphone);
export const DesktopWindowsOutlinedIcon = /* #__PURE__ */ createLucideIcon('DesktopWindowsOutlined', Monitor);
export const LockIcon = /* #__PURE__ */ createLucideIcon('Lock', Lock);
export const LockOutlinedIcon = /* #__PURE__ */ createLucideIcon('LockOutlined', Lock);
export const VpnKeyOutlinedIcon = /* #__PURE__ */ createLucideIcon('VpnKeyOutlined', KeyRound);
export const LocationOnIcon = /* #__PURE__ */ createLucideIcon('LocationOn', MapPin);
export const BusinessIcon = /* #__PURE__ */ createLucideIcon('Business', Building2);
export const ApartmentIcon = /* #__PURE__ */ createLucideIcon('Apartment', Building);
export const SchoolIcon = /* #__PURE__ */ createLucideIcon('School', GraduationCap);
export const RocketLaunchOutlinedIcon = /* #__PURE__ */ createLucideIcon('RocketLaunchOutlined', LayoutTemplate);
export const BadgeIcon = /* #__PURE__ */ createLucideIcon('Badge', IdCard);
export const SmartToyIcon = /* #__PURE__ */ createLucideIcon('SmartToy', Bot);
export const AutoAwesomeIcon = /* #__PURE__ */ createLucideIcon('AutoAwesome', Sparkles);
// GAP: Lucide has no two-tone variants; falls back to the plain outline glyph.
export const AutoAwesomeTwoToneIcon = /* #__PURE__ */ createLucideIcon('AutoAwesomeTwoTone', Sparkles);
